<template>
  <el-dialog
    :modal-append-to-body="false"
    :visible.sync="visible"
    :title="$t('Integrations_ActiveDirectory_SyncListsDialog_Title')"
    width="400px"
    center
  >
    <rest-form
      :model="taskModel"
      :save-endpoint="saveEndpoint"
      :success-message="
        $t('Integrations_ActiveDirectory_SyncListsDialog_SuccessMessage')
      "
      :rules="rules"
      ref="form"
    >
      <el-row>
        <rest-form-item
          prop="whitelist_groups"
          :hint="
            $t('Integrations_ActiveDirectory_Field_WhitelistGroups_Description')
          "
        >
          <el-switch
            v-model="taskModel.whitelist_groups"
            :active-text="
              $t('Integrations_ActiveDirectory_Field_WhitelistGroups')
            "
          />
        </rest-form-item>

        <rest-form-item
          v-if="taskModel.whitelist_groups"
          prop="whitelisted_groups"
          :hint="
            $t(
              'Integrations_ActiveDirectory_Field_WhitelistedGroups_Description'
            )
          "
        >
          <el-input
            type="textarea"
            v-model="taskModel.whitelisted_groups"
            :rows="6"
          ></el-input>
        </rest-form-item>
      </el-row>

      <el-row type="flex" justify="center">
        <el-button type="primary" @click="save">
          {{ $t('Integrations_ActiveDirectory_SyncListsDialog_StartSync') }}
        </el-button>
      </el-row>
    </rest-form>
  </el-dialog>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'ActiveDirectorySyncListsDialog',

  components: { RestFormItem, RestForm },

  data() {
    return {
      visible: false,
      taskModel: {}
    }
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  computed: {
    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `integrations/active-directory/${this.model.id}/sync-lists`
      })
    },

    rules() {
      return {
        daterange: {
          required: true
        }
      }
    }
  },

  methods: {
    show() {
      this.taskModel = {
        whitelist_groups: this.model.params.whitelist_users,
        whitelisted_groups: this.model.params.whitelisted_groups
      }

      this.visible = true
    },

    save() {
      this.$refs['form'].save().then(taskRecord => {
        this.$router.push(
          projectRoute({
            name: 'TaskHistoryView',
            query: { id: taskRecord.id }
          })
        )
      })
    }
  }
}
</script>

<style scoped>
>>> .el-row {
  margin-bottom: 20px;
  word-break: break-word;
}

>>> .el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/activedirectory/ActiveDirectorySyncListsDialog.vue